// HACKS for compiling
// declare function noty(options);
// declare var swal;
// interface JQueryStatic {
//   noty: any;
// }
// declare var Sortable: any;
// interface Window { swal: any; }
interface Window { moment: any; ga: any; }

module finadai.services.util {
	export var NAME = "utilsService";
	
	
	function proxifier($location: ng.ILocationService) {
		return function(withApi, apiVersion){
      var api = '/api/';
			apiVersion = apiVersion || 'v1';
      if(angular.isDefined(withApi) && withApi === false){
        api = '';
        apiVersion = '';
      }
			switch ($location.host()) {
                case 'finadaiapp.test':
                    return 'http://finadai.api' + api + apiVersion;
                case 'finadai.app':
                    return 'http://finadai.api' + api + apiVersion;
                case 'admin.finadai.local':
                    return '//api.finadai.local' + api + apiVersion;
                case 'finadaiapp.app':
                    return 'http://finadai.app' + api + apiVersion;
                case 'app.quam.mx':
                    return 'https://quam-api-prod-8g2we.ondigitalocean.app' + api + apiVersion;
                case 'holiday.quam.mx':
                    return 'http://api.quam.mx' + api + apiVersion;
                case 'testholiday.quam.mx':
                    return 'http://testapi.quam.mx' + api + apiVersion;
                case 'testapp.quam.mx':
                    return 'https://quam-qa-app-e4snd.ondigitalocean.app' + api + apiVersion;
                case 'hsbcapp.test':
                    return 'http://hsbc.api' + api + apiVersion;
                case '127.0.0.1':
                    return 'http://localhost:8088' + api + apiVersion;
                case 'localhost':
                    return 'http://localhost:8088' + api + apiVersion;
                case 'quam-app-qa.netlify.app':
                    return 'https://quam-qa-app-e4snd.ondigitalocean.app' + api + apiVersion;
                case 'quam-app.netlify.app':
                    return 'https://quam-api-prod-8g2we.ondigitalocean.app' + api + apiVersion;
            }
		}
	}

	function notify($mdToast){
        return function (message, type, delay) {
            if (angular.isUndefined(type)) {
                type = 'success'
            }
            if (angular.isUndefined(delay)) {
                delay = 8000
            }
            $mdToast.show({
                controller: ($mdToast, $scope) => {
                    $scope.closeToast = () => $mdToast.hide()
                },
                template: '<md-toast class="md-toast-' + type + '"><span flex>' + message + '</span> <md-button ng-click="closeToast()" translate> Cerrar </md-button> </md-toast>',
                hideDelay: delay,
                position: 'top right'
            });
        }
	}

	function confirm($mdDialog: ng.material.IDialogService){
		return (title, content, target, okText, cancelText) => {
			okText = okText || 'si';
			cancelText = cancelText || 'no';
			var confirmOpt = $mdDialog.confirm()
          .title(title)
          .textContent(content)
          .targetEvent(target)
          .ok(okText)
          .cancel(cancelText);
			return $mdDialog.show(confirmOpt);
		}
	}
	
	export function toParams(obj):string {
    var params = [];
    for(var key in obj){
      params.push(key + '=' + encodeURIComponent(obj[key]))
    }
    return params.join('&');
  }

	function BackendValidationInterceptor($injector, $q:ng.IQService){
		return {
			responseError: function(rejection: ng.IHttpPromiseCallbackArg<models.http.responses.Error>) {
        var config: any = rejection.config;
        if(angular.isUndefined(config.ignoreBEValidation) && !config.ignoreBEValidation){
          if(rejection.status == 412 || rejection.status == 422 || rejection.status == 400){
            var errorsMessage = angular.isDefined(rejection.data.message) ? rejection.data.message : "Error";
            var output = '<span class="block">' + errorsMessage + '</span>';
            if(typeof rejection.data.errors !== "string"){
              output = '<span class="block mt10">' + errorsMessage + '</span>';
              output+='<ol>';
              for(var field in rejection.data.errors){
                for(var errorType in rejection.data.errors[field]){
                  var errorString = angular.isDefined(rejection.data.errors[field][errorType]["error"]) ? rejection.data.errors[field][errorType]["error"] : rejection.data.errors[field][errorType];
                  output+='<li>' + errorString + '</li>';
                }
              }
              output+='</ol>';
            }
            $injector.get('notify')(output, 'danger');
          }
          if(rejection.status == 403){
            $injector.get('notify')("Acceso no autorizado", 'danger')
          }
          if(rejection.status == 500){
            $injector.get('notify')('Ha ocurrido un error interno, favor de contactar al administrador', 'danger')
          }
        }
        return $q.reject(rejection);
			}
		}
	}
	
	export function PropertiesTransformInterceptor(_data, headers: ng.IHttpHeadersGetter, status){
		function addParsedDateReturn (__item){
			if(__item != null && !angular.isArray(__item) && angular.isDefined(__item.date) && angular.isDefined(__item.timezone)){
        __item._date = window.moment(__item.date).tz(__item.timezone).toDate();
			}
      return __item;
		}

    function processData(__data) {
      for(var key in __data){
        __data[key] = addParsedDateReturn(__data[key]);
        if(angular.isArray(__data[key]) || angular.isObject(__data[key])){
          __data[key] = processData(__data[key]);
        }
      };
      return __data;
    }
		
		if(headers('Content-Type') == 'application/json'){
			var data = angular.fromJson(_data);
      var copiedData = processData(angular.copy(data));
			return copiedData;
		}
		return _data;
	}
  
  export var DateShortFormatFinadai = 'dd/MMM/yyyy';
  export var DateLongFormatFinadai = "dd/MMM/yyyy',' hh:mma";
	
	export function run() {
		var utilsService = angular.module(NAME, []);
		utilsService.service("backendValidationInterceptor", BackendValidationInterceptor);
		utilsService.service("proxifier", proxifier);
		utilsService.service("notify", notify);
		utilsService.service("confirm", confirm);
		utilsService.config(($httpProvider:ng.IHttpProvider) => {
			$httpProvider.defaults.transformResponse = [PropertiesTransformInterceptor];
			$httpProvider.interceptors.push("backendValidationInterceptor");
    })
    utilsService.run( () => {
      window.moment.defineLocale('es', {
        months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split("_"),
        monthsShort: "Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic".split("_"),
        weekdays: "Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado".split("_"),
        weekdaysShort: "Dom_Lun_Mar_Mie_Jue_Vie_Sab".split("_"),
        weekdaysMin: "Do_Lu_Ma_Mi_Ju_Vi_Sa".split("_"),
        longDateFormat: {
          LT: "h:mmA",
          LTS: "h:mm:ssA",
          L: "DD/MM/YYYY",
          LL: "D MMMM YYYY",
          LLL: "D MMMM YYYY LT",
          LLLL: "dddd, D MMMM, YYYY LT"
        },
          calendar : {
              sameDay : function () {
                  return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
              },
              nextDay : function () {
                  return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
              },
              nextWeek : function () {
                  return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
              },
              lastDay : function () {
                  return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
              },
              lastWeek : function () {
                  return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
              },
              sameElse : 'L'
          },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años',
        },
        // ordinalParse : /\d{1,2}º/,
        // ordinal : '%dº',
        // in case the meridiem units are not separated around 12, then implement
        // this function (look at locale/id.js for an example)
        // meridiemHour : function (hour, meridiem) {
        //     return /* 0-23 hour, given meridiem token and hour 1-12 */
        // },
        meridiem: function (hours, minutes, isLower) {
          return hours < 12 ? 'am' : 'pm';
        },
        week: {
          dow: 1, // Monday is the first day of the week.
          doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
      });
    })
	}
}
finadai.services.util.run();
